import { ViewerComponent } from "./Landing";

const InfoSecurityPolicy = () => {
    return   <div style={{ marginTop: 0, backgroundColor: '#fff', paddingTop: '20px', height: '100vh', borderRadius: '10px' }}>
        <div style={{display: 'flex', justifyContent: 'center', fontWeight: 600, marginBottom: 10}}><span>Chính sách bảo mật thông tin</span></div>
          <ViewerComponent fileUrl={'pdf/chinh-sach-bao-mat-thong-tin.pdf'} />
     </div>
}

export default InfoSecurityPolicy;